import React from 'react';
import { componentService } from 'js/services/component.service';

export const ProductLimits = React.lazy(() => import(/* webpackChunkName: "product-limits" */ './ProductLimits'));

componentService.registerPageComponents({
    'product-loss-limit': ProductLimits,
    'product-bet-limit': ProductLimits
});
